"use client";

import React, { useState } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import Lottie from "lottie-react";

// Interface for online Lottie animations
interface OnlineLottieAnimationProps {
  src: string;
  className?: string;
  loop?: boolean;
  autoplay?: boolean;
  style?: React.CSSProperties;
}

// Interface for local JSON animations
interface LocalLottieAnimationProps {
  animationData: object;
  className?: string;
  loop?: boolean;
  autoplay?: boolean;
  style?: React.CSSProperties;
}

// Component for online Lottie animations
export function OnlineLottieAnimation({
  src,
  className = "",
  loop = true,
  autoplay = true,
  style = {},
}: OnlineLottieAnimationProps) {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return (
      <div
        className={`${className} bg-gradient-to-br from-primary/10 to-accent/10 rounded-lg`}
        style={style}
      />
    );
  }

  return (
    <DotLottieReact
      src={src}
      className={className}
      loop={loop}
      autoplay={autoplay}
      style={style}
      onError={() => setHasError(true)}
    />
  );
}

// Component for local JSON animations
export function LocalLottieAnimation({
  animationData,
  className = "",
  loop = true,
  autoplay = true,
  style = {},
}: LocalLottieAnimationProps) {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return (
      <div
        className={`${className} bg-gradient-to-br from-primary/10 to-accent/10 rounded-lg`}
        style={style}
      />
    );
  }

  try {
    return (
      <Lottie
        animationData={animationData}
        className={className}
        loop={loop}
        autoplay={autoplay}
        style={style}
      />
    );
  } catch (error) {
    setHasError(true);
    return null;
  }
}

// Online Lottie animations (Mission and Vision)
export function MissionAnimation() {
  return (
    <OnlineLottieAnimation
      src="https://lottie.host/ba43b30b-d4fa-4c6c-a610-35a0b69f48fb/IgW3FwWRVq.lottie"
      className="w-full h-full"
      style={{ maxWidth: "100%", height: "auto" }}
    />
  );
}

export function VisionAnimation() {
  return (
    <OnlineLottieAnimation
      src="https://lottie.host/0bdf0dfd-8b95-4911-9db3-5e064de2b61d/ljOAJCUgth.lottie"
      className="w-full h-full"
      style={{ maxWidth: "100%", height: "auto" }}
    />
  );
}

export function CTAAnimation() {
  return (
    <OnlineLottieAnimation
      src="https://lottie.host/e445acc5-a554-4b51-8151-ccef7899e339/GqhaMFLwY2.lottie"
      className="w-1/2 h-1/2 text-center mx-auto"
      style={{ maxWidth: "100%", height: "auto" }}
    />
  );
}

// Local JSON animations
import voiceAgentAnim from "../../../public/animation/Voice.json";
import chatbotAnim from "../../../public/animation/Chatboat.json";
import ragAnim from "../../../public/animation/RAG.json";
import workflowAnim from "../../../public/animation/WorfFlow.json";
import customSolutionAnim from "../../../public/animation/Coustom.json";
import securityAnim from "../../../public/animation/Security.json";
import customerSupportAnim from "../../../public/animation/Support.json";
import appointmentAnim from "../../../public/animation/appointment.json";
import leadAnim from "../../../public/animation/automation.json";
import marketingAnim from "../../../public/animation/Marketing.json";
import dataDrivenAnim from "../../../public/animation/data-driven.json";

export function VoiceAgentAnimation() {
  return <LocalLottieAnimation animationData={voiceAgentAnim} className="w-full h-[20rem]" />;
}

export function ChatbotAnimation() {
  return <LocalLottieAnimation animationData={chatbotAnim} className="w-full h-[20rem]" />;
}

export function RAGAnimation() {
  return <LocalLottieAnimation animationData={ragAnim} className="w-full h-[20rem]" />;
}

export function WorkflowAnimation() {
  return <LocalLottieAnimation animationData={workflowAnim} className="w-full h-[20rem]"  />;
}

export function CustomSolutionAnimation() {
  return <LocalLottieAnimation animationData={customSolutionAnim} className="w-full h-[20rem]"/>;
}

  export function SecurityAnimation() {
    return <LocalLottieAnimation animationData={securityAnim} className="w-full h-[20rem]" />;
}

export function CustomerSupportAnimation() {
  return <LocalLottieAnimation animationData={customerSupportAnim} className="w-full h-[20rem]" />;
}

export function AppointmentAnimation() {
  return <LocalLottieAnimation animationData={appointmentAnim} className="w-full h-[20rem]" />;
}

export function LeadAnimation() {
  return <LocalLottieAnimation animationData={leadAnim} className="w-full h-[20rem]" />;
}

export function MarketingAnimation() {
  return <LocalLottieAnimation animationData={marketingAnim} className="w-full h-[15rem]" />;
}

export function DataDrivenAnimation() {
  return <LocalLottieAnimation animationData={dataDrivenAnim} className="w-full h-[15rem]" />;
}
